/*eslint-disable*/
import { getPresentationalFiltersWithSortEnabledField } from '../../helpers/filtersHelpers';

export const searchServicesFilterMiddleware = (action, state) => {
  const { value, fieldName } = action.payload;
  const { data, filters } = state;
  const trueValue = value.toLowerCase().trim();

  const allFilters = getPresentationalFiltersWithSortEnabledField(
    data[fieldName],
    filters[fieldName]
  );

  const newPresentationalFilters = trueValue.length
    ? allFilters.filter(option => {
        const { name } = option;

        return name
          .toLowerCase()
          .replace(/ё/g, 'е')
          .includes(trueValue.replace(/ё/g, 'е'));
      })
    : allFilters;

  return {
    ...state,
    searchValues: {
      ...state.searchValues,
      [fieldName]: value,
    },
    presentationalFilters: {
      ...state.presentationalFilters,
      [fieldName]: newPresentationalFilters,
    },
  };
};
